import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function CreateCommentIconSvg() {
  return (
    <svg
      width="27"
      height="19"
      viewBox="0 0 27 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="17" r="2" fill="white" />
      <rect x="7" width="20" height="12" rx="2" fill="white" />
      <path d="M 7 9 L 2 17 L 11 9 Z" fill="white" />
      <circle cx="12" cy="6" r="1.2" fill="#475569" />
      <circle cx="17" cy="6" r="1.2" fill="#475569" />
      <circle cx="22" cy="6" r="1.2" fill="#475569" />
    </svg>
  )
}

function SelectedCreateCommentIconSvg() {
  return (
    <svg
      width="27"
      height="19"
      viewBox="0 0 27 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="17" r="2" fill="#eab308" />
      <rect x="7" width="20" height="12" rx="2" fill="#eab308" />
      <path d="M 7 9 L 2 17 L 11 9 Z" fill="#eab308" />
      <circle cx="12" cy="6" r="1.2" fill="#475569" />
      <circle cx="17" cy="6" r="1.2" fill="#475569" />
      <circle cx="22" cy="6" r="1.2" fill="#475569" />
    </svg>
  )
}

export default function CreateCommentIcon(
  props: Partial<CustomIconComponentProps> & { selected?: boolean }
) {
  const { selected, ...rest } = props

  if (selected)
    return <Icon component={SelectedCreateCommentIconSvg} {...rest} />

  return <Icon component={CreateCommentIconSvg} {...rest} />
}

CreateCommentIcon.defaultProps = {
  selected: undefined
}
